import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails22 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery24.jpg";
    return (
        <>
            {/* <div className="body_wrap">
        <div className="page_wrap"> */}
           <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      

            <Header />
            <div
                data-elementor-type="cpt_layouts"
                data-elementor-id="46"
                className="elementor elementor-46"
            >
                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="52ebb12"
                    data-element_type="section"
                    data-settings='{"background_background":"classic"}'
                    style={{ height: "30rem", marginBottom: "5rem" }}
                >
                    <div className="elementor-background-overlay"></div>
                    <div className="elementor-container elementor-column-gap-extended">
                        <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
                            data-id="ae9d67e"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <section
                                    className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                    data-id="fcf91b3"
                                    data-element_type="section"
                                >
                                    <div className="elementor-container elementor-column-gap-extended">
                                        <div
                                            className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                                            data-id="93dfaf4"
                                            data-element_type="column"
                                        >
                                            <div className="elementor-widget-wrap elementor-element-populated">
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                                                    data-id="847c2c5"
                                                    data-element_type="widget"
                                                    data-widget_type="spacer.default"
                                                    style={{ height: "8rem" }}
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div className="elementor-spacer">
                                                            <div className="elementor-spacer-inner"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                                                    data-id="8fe49e3"
                                                    data-element_type="widget"
                                                    data-widget_type="trx_sc_layouts_title.default"
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div
                                                            id="trx_sc_layouts_title_515615674"
                                                            className="sc_layouts_title sc_align_center with_content without_image without_tint"
                                                        >
                                                            <div className="sc_layouts_title_content">
                                                                <div className="sc_layouts_title_title">
                                                                    {" "}
                                                                   
                                                                </div>
                                                                <div className="sc_layouts_title_breadcrumbs">
                                                                    <div className="breadcrumbs">
                                                                         
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
 */}



            <div className="page_content_wrap blog-details">
                <div className="content_wrap" >
                    <div className="content">
                        <div id="container" className="give-wrap container">
                            <div id="content" role="main">
                                <div
                                    id="give-form-288-content"
                                    className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                                >
                                    <div
                                        id="give-sidebar-left"
                                        className="give-sidebar give-single-form-sidebar-left"
                                    >
                                        <div className="images">
                                            <img
                                                width="1024"
                                                height="576"
                                                src={img1}
                                                className="attachment-large size-large wp-post-image blog-img"
                                                alt=""
                                                decoding="async"
                                                sizes="(max-width: 1024px) 100vw, 1024px"
                                            />
                                        </div>
                                    </div>
                                    <div className="summary entry-summary">
                                        <h2 itemProp="name" className="give-form-title entry-title">
                                            માલડે અને જેસલ-સંતમિલન


                                        </h2>{" "}
                                        <div
                                            id="give-form-288-wrap"
                                            className="give-form-wrap give-display-onpage"
                                        >
                                            <div className="give-goal-progress">
                                                <div
                                                    className="raised blog-title"
                                                   
                                                >
                                                    <span className="income"> માલડે અને જેસલ-સંતમિલન

                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                id="give-form-content-288"
                                                className="give-form-content-wrap give_pre_form-content"
                                            >
                                                <p className="paragraph-content">
                                                    ગુંજામાં શ્રી રામદેવજીએ પાટપૂજા, મંડપમેળાનો સમારંભ કરવાની મ
                                                    ખીમડાને મંડપના કોટવાળ તરીકે નક્કી કરીને તેને ખબર આપી.
                                                    સાખી
                                                    રામે મંડપ રોપિયો, ગામ રણુંજા માંય, ખીમડિયાને ખબર દઈ, તેડાવ્યો છે ત્યાંય, વાયક બીડલાં વાળિયાં, ખીમડિયો લઈ જાય, ગતગંગાને નોંતરે, મંડપ મેળો થાય. .
                                                    *
                                                    ખીમડો રણુજામાં આવતાં રામદેવજીએ વાયકના બીડાં વાળી ખીમડાનેર અને જ્યાં જ્યાં સંતો- ભક્તોનાં સ્થાન છે ત્યાં ત્યાં પહોંચાડવા આજ્ઞા કરી, બીડું ખીમડાને આપ્યું. ખીમડે વાયક બીડાને માથે ચડાવ્યું.
                                                    સાખી
                                                    પરથમ વાયક પૂજતાં, ખીમડિયો હરખાય;
                                                    ધૂપ ધજા કરમાં ધરી, લાગ્યો પીરને પાય.
                                                    ભજન
                                                    જી રે સંતો થયા રે તૈયાર, એજી રે હૈડે હરખ્યા અપાર, આજ વાયક વધાવે રામાપીરનાં એ...જી...હોજી રણુંજામાં ભક્તોએ વાયકને પ્રેમથી વધાવી લીધાં. ખીમડો ત્યાંથી પરગામ જવા ચાલી નીકળ્યો.
                                                    સાખી
                                                    ત્યાંથી ખીમડો આવિયો, આનુગાની માંચ, મળિયાં નીલમબાઈ ને મળિયા કુંભો રાય.

                                                </p>
                                                <p className="paragraph-content">
                                                    ભજન
                                                    જીરે સંતો થયા રે તૈયાર, એ જી રે હૈડે હરખ્યા અપાર
                                                    
                                                    આજ વાયક વધાવે રામાપીરનાં...એ...હો, રણુંજામાંથી ખીમડો આબુગઢ આવ્યો અને સતી નીલમબાઈ અને કુંભારાણાને
                                                    મળ્યો. સંત સતીએ વાયક હરખભેર વધાવ્યાં.
                                                    સાખી
                                                    ત્યાંથી ખીમડો આવિયો, પાટણ શે'રની માંય, ઉગમશી બાવો મળ્યા, મળિયા જેમલરાય.
                                                    ભજન
                                                    જી રે સંતો થયા રે તૈયાર, એજી હૈડે હરખ્યા અપાર,
                                                    આજ વાયક વધાવે રામાપીરનાં... એ જી...હોજી
                                                    ખીમડો પાટણ શહેરમાં આવ્યો અને જેમલ રાઠોડને અને સિદ્ધ સંત મનાતા ઉગમશી બાવાને મળ્યો. બન્ને સંતોએ ભક્તિભાવે વાયક વધાવીને રણુંજા જવાની તૈયારી કરી.
                                                    સાખી
                                                    ત્યાંથી ખીમડો આવિયો, મજેવડીની માંય, સંત દેવતણખી મળ્યા, મળિયાં નીલમબાઈ.
                                                    ભજન
                                                    જી રે સંતો થયા હૈ તૈયાર, એજી ઉંડે હરખ્યા અપાર, આજ વાયક વધાવે રામાપીરનાં... એ જી...હો ખીમડો સૌરાષ્ટ્રમાં મજેવડી ગામમાં રહેતા સંત દેવતણખી અને તેમની પુત્રી સતી નીલમબાઈને મળ્યો. તેમણે વાયક વધાવી લીધું અને તેઓ રણુંજા જવા તૈયાર
                                                    થયાં.
                                                    સાખી
                                                    ત્યાંથી ખીમડો આવિયો, કોળાંભા જે ગામ, હાલા, હુલાને મળ્યો, ઢાંગા વનવીર નામ.


                                                </p>
                                                <p className="paragraph-content">
                                                    જી રે સંતો થયા રે તૈયાર, એ જી હેડે હરખ્યો. અપાર, આજ વાયક વધાવે રામાપીરનાં...એ જી...હો
                                                    ખીમડો કોળાંભા નામના ગામમાં આવ્યો અને દેવાયત પંડિયન બ્ધિ હાલો, હુલો, ઢાંગો અને વનવીર એ ચારેય ભક્તોને વાયક પહોંચાડ્યાં.
                                                    સાખી
                                                    ત્યાંથી ખીમડો આવિયો, વંથળી ગામ મોજાર, દેવાયત પંડિત મળ્યા, મળ્યાં દેવલદે નાર.
                                                    ભજન
                                                    જી રે સંતો થયા રે તૈયાર, એ જી હૈડે હરખ્યા અપાર, ખીમડો વંથળી ગામમાં આવ્યો અને ચમત્કારિક સિદ્ધ સંત અને મહાન આજ વાયક વધાવે રામાપીરનાં... એ જી...હોજી મનાતા દેવાયત અને સતી દેવલને મળ્યો. સંત સતીએ હરખભેર વાયક વધારે
                                                    રણુંજા જવાની તૈયારી કરી.
                                                    સાખી
                                                    ત્યાંથી ખીમડો આવિયો, અંજાર શે'ર મોજાર, જાડેજો જેસલ મળ્યા, મળ્યા તોરલદે નાર. ભજન 
                                                    જી રે સંતો થયા રે તૈયાર, એ જી હૈડે હરખ્યા અપાર, આજ વાયક વધાવે રામાપીરનાં... એ જી ...હોજી ખીમડો અંજાર શહેરમાં આવ્યો અને જેસલપીરને અને સતી તોરલને મળ્યો. જેસલ અને તોરલે હરખભેર વાયક વધાવ્યાં અને ખીમડાને પૂછ્યું કે, ‘હવે અહીંથ ક્યાં જવાના છો ?’ ખીમડે કહ્યું કે, ‘હવે અહીંથી મેવાડમાં મેવાસા ગામે સં માલદેજી અને સતી રૂપાંદેને વાયક પહોંચાડી રણુંજા જઈશ.' જેસલને રાઓલ માલદે અને રૂપાંદેનાં દર્શન કરવાની ઘણા વખતથી ઇચ્છા હતી. એટલે એ પ વહેલા તૈયાર થયા ને માલદેવજી અને રૂપાંદેનાં દર્શન કરવા પ્રથમ મેવાસામાં તેમની સાથે સાથે રણુંજા જવું એવું નક્કી કર્યું.
                                                    સાખી
                                                    ત્યાંથી ખીમડો આવિયો, મેવાસાની માંય, રાણી રૂપાંદે મળ્યાં, મળ્યાં. માલદેરાય
                                                </p>
                                                <p className="paragraph-content">
                                                    રે સંતો થયા છે તૈયાર, એ જી હૈડે હરખ્યા અપાર,
                                                    આજ વાયક વધાવે રામાપીરનાં... એ જી ...હોજી
                                                    ૧૯
                                                    લીમડો અંજારથી નીકળી મેવાડમાં મેવાસા ગામમાં સંત માલદેવજી અને સતી ને મળ્યો. સંત સતીએ હરખભેર વાયક વધાવ્યાં અને ખીમડાને પૂછ્યું કે, તમે તેથી આવો છો ? ખીમડે કહ્યું કે, હું અંજાર શહેરમાં સંત જૈસલ જેઓ સતી ૫ ભક્તિભાવથી સિદ્ધિને પામ્યા છે, એમને વાયક પહોંચાડી અહીં આવ્યો હવે અહીંથી રણુંજા જઈશ. માલદે અને રૂપાંદેએ જેસલ તોરલના ભક્તિ ભાગની ધણા સ્થળે પ્રશંસા સાંભળી હતી, તેથી તેમને જેસલ તોરલનાં દર્શન ની ઇચ્છા હતી, તેથી સંત-સતીએ નિશ્ચય કર્યો કે અંજાર જઈ જેસલ તોરલ રવા સંત સતીનાં દર્શન કરી, ત્યાંથી સૌ સાથે જ રણુંજા જવા નીકળીએ. આમ વિર કરી માલદે ને રૂપાંદે અંજાર તરફ નીકળ્યાં. જેસલ તોરલ મેવાસામાં માલદે રૂપાંદેનાં દર્શન કરી રણુંજા સાથે જઈશું એવી કવનાથી અંજારથી નીકળ્યાં. જેસલ અને માલદે કોઈ મંડપમેળામાં ભેગા થયેલા મિ. એટલે ઘણા વખતથી પરસ્પર મળવાની ઇચ્છા હતી અને એવી જ ઇચ્છા ગાંઠે અને તોરલની હતી, તેથી તેઓ એકબીજાને મળવા હરખભેર ચાલતાં હતાં.
                                                    ભજન
                                                    કચ્છથી જેસલ ઉમાવો, મેવાડ માલો આરાધે, સુરિનર મળ્યા મુનિવરા, ભોમ આવી આઘો આઘે, માલે જેસલને પૂછિયું, આપણે થઈ ઓળખાણ, હાથ થઈ પંજા મેળવ્યા, થયાં ત્યાં સિદ્ધનાં સંધાન. ધરે જીત્યો ઘોરી નમે, કૂવે કડવાં રે પાણી, આરાધે અમૃત થયાં, એ માલા ઘેર રાણી, સાવ સોનાની બારંગી, માંહી બેઠાં રૂપાંદે રાણી. માગ્યા મેહને વરસાવિયા, ઈ તોરલ કાઠિયાણી, વાવી જાળ, જેસલે વાવી પીપળી, માલે ડાળ્યો બ્રહ્માંડે પહોંચતી, મૂળ તો ગયાં રે પાતાળ. ધનવે ડુંગર સંતોએ પગ ધર્યા, સૌએ લીધો વિસામો,

                                                </p>
                                                <p className="paragraph-content">
                                                    શમદેવપીરના આરાધનો, જાગ્યો. ભજનનો કાર્યો,
                                                    પર્વત
                                                    પાળમાં
                                                    જ્ઞ
                                                    ગ
                                                    કોચી,
                                                    ****
                                                    કાળી રહેશે. પીંપળ પુરાણી, સતિયાએ સત રોપિયાં, બોલ્યાં તોલદે વાણી. અંજારથી જેસલ તોરલ મેવાસા જવા નીકળેલાં, એવી જ રીતે મેવાસાથી જવા રાઓલ માલદે અને રૂપાંદે નીકળેલાં, મેવાડ અને સિંધની સરહદ ઉપર સંતો સામસામા મળ્યાં. સોનાની ભારંગી વેલમાં રૂપાંદે બેઠાં હતાં. તોરલ 8 વેલમાં હતાં. પરસ્પર કોઈને ઓળખતાં નહિ હોવાથી રાઓલ માલદેએ પૂછ્યું કે તમારે ક્યાં જવું છે ? જેસલે ઉત્તર આપ્યો કે અમે મેવાસામાં સંત માલદેજનાં દર્શન જઈએ છીએ . તમારે ક્યાં જવું છે ? માલદેએ જવાબ આપ્યો કે, અમે અંજારમાં સંત જેસલપીરનાં દર્શને જઈએ છીએ.
                                                    બંને પરસ્પર ઓળખી ગયા. વેલમાંથી સંત-સતીઓ ઊતરી પડ્યાં ને ભેટ્યાં જેસલ અને માલદેશ એકબીજાને અંતરમાં ગુરુ માની પંજા મેળવી ભેટી પડ્યા. રૂપાંદે ને તોરલ પણ ‘જય રામદેવજી’ કહી ભેટી પડ્યાં. ધોમધખતા તાપમાં વેલમાં બેસીને વાતો શી રીતે થાય ? ક્યાંક વૃક્ષની છાયાએ બેસવા પરસ્પર વિચારતા હતા. દૂર દૂર નજર કરતાં ક્યાંય વૃક્ષ જણાતું ન હતું. માલદેને મનમાં થયું કે જેસલપીર કહેવાય છે, તો એમની પીરાઈ જોવાની તક ઠીક છે, એમ વિચારીને જેસલને કહ્યું કે આપ પીર મનાવ છો, શ્રી રામદેવજી સમર્થે પધારે છે એમ મેં સાંભળ્યું છે. તો જો અહીં એક વૃક્ષ હોત તો આપણે બે ઘડી વિસામો લેવા બેસત ને સત્સંગ થાત.
                                                    માલદેની વાત જેસલ તુરત સમજી ગયા અને રામદેવજીનું સ્મરણ કરી પોતાની ઝોળીમાંથી પીંપળાનું દાતણ કાઢીને વાવ્યું. ત્યાં તો જોતજોતામાં ત્યાં પીંપળી પ્રગટ થઈ. તેમ છતાં જેસલ બોલ્યો : ‘આ પીપળી ખરી પણ એની છાયા કેટલી ? આપ તો સમર્થ સંત છો. કોઈ મોટું વૃક્ષ હોય તો એના છાંયે બેસી બે ઘડી ભજન ભાવ કરીએ. માલદે સમજી ગયા કે જેસલ મારી પરીક્ષા કરવા ઇચ્છે છે. એ જ વખતે માલદેવજીએ પોતાની વેલમાંથી જાળનું દાતણ કાઢી વાવ્યું અને જોતજોતામાં ત્યાં મોટું વૃક્ષ થઈ ગયું !
                                                    જાળની છાંયામાં ચારે સંતસતીઓ બેઠાં. ત્યાં તોરલે રૂપાંદેની પરીક્ષા કરવા કહ્યું કે, તમે તો સંતનાં પણ સંત છો. વૃક્ષની છાંય તો થઈ, બેઠાં પણ ખરાં, પરંતુ જો હવે અહીં પાણીની સગવડ હોય તો તૃષા છીપાવત.' એ વખતે રૂપાંદેએ


                                                </p>
                                                <p className="paragraph-content">
                                                    રામદેવજીનું સ્મરણ કરી ત્યાં વીરડી ગાળી અને પાણીથી એ વીરડી ભરાઇ ગઇ એ વખતે તોરલે રૂપાંદેને કહ્યું કે ‘મેવાડમાં કૂવાનાં પાતાળપાળી હોય છે અને તે કડવાં પણ હોય છે, એમ મેં સાંભળ્યું છે. એટલે આ વીરડીનું પાણી સહેજ કડવું લાગે છે. આપ તો મહાન ભક્ત છો. આપના આરાધે તો આકાશમાંથી મોજડી ઊતરી હતી, થાળમાં બગીચો ખીલ્યો હતો. એમ મેં સાંભળ્યું છે, તો આ વીડીનું પાણી કાયમ મીઠું રહે તેમ કરી તો આનંદ થાય.'
                                                    એ સમયે રૂપાંદેએ રામદેવજીનું સ્મરણ કર્યું અને વીરડીનું પાણી મીઠું થયું. છેવટે તો૨લે મેઘરાજાની સ્તુતિ કરી અને મેહ વરસાવી વીરડીને અખંડ જળ ભરેલી રહે એવી પ્રાર્થના કરી. ત્યાંથી ચારેય જણા ધનવા નામના ડુંગરે આવ્યાં અને ત્યાં રાત્રિ રહ્યાં. ત્યાં પથ્થર પર ઓળખાણની નિશાની કોતરી અને ત્યાંથી બીજે દિવસે રણુંજાના મંડપમેળામાં ગયાં. આ સંતો પ્રથમ મળ્યાં એ સ્થળે પ્રકટ થયેલી જાળને આજે માલાની જાળને નામે સૌ કોઈ ઓળખે છે, અને જેસલે વાવેલી પીંપળી પણ જેસલની પીંપળીના નામે ઓળખાય છે.

                                                </p>
                                                <p className="paragraph-content">
                                                    સાંઢિયો ઘણો થાકી ગયો હતો; તેથી થાક ઉતારતા ત્યાં જ બેઠાં અને થાક - પરિશ્રમથી ત્રણે જણાં નિદ્રાધિન થયાં.
                                                    સવારના ચાર વાગવાના સુમારે ઢોલ, નગારાં, શરણાઈઓનો નાદ રતનાને કાને પડતાં તે જાગ્યો અને સહુને રામા સરોવરને કાંઠે આવેલા જોઈને આશ્ચર્યથી ‘જય રામાપીર’ એમ બોલી ઊઠ્યો, સગુણા પણ ઘોષણા સાંભળતાં જાગી. પોતાને રામા સરોવરને કાંઠે જોતાં તે હર્ષઘેલી થઈ ગઈ અને હરખઘેલો રતનો ઝડપથી બધાંને દરબારગઢમાં લઈ ગયો.
                                                    માતા મિણલદે, લાસાંબહેન, લક્ષ્મીબહેન વગેરે સગુણાને આવેલાં જોઈ હર્ષથી ભેટી પડચાં. બધાને ઘણો આનંદ થયો.
                                                    રામદેવજી શણગાર સજતા હતા, ત્યાં સગુણા આવી પહોંચ્યાં. તે બોલે તે પહેલાં જ ‘બહેન ! તું વખતસર આવી પહોંચી તેથી મને ઘણો આનંદ થયો.’ રામદેવજીએ કહ્યું.
                                                    ‘ભાઈ ! આ બધો તમારો પ્રતાપ છે. વનવગડે બહેનનો પોકાર સાંભળી તમે ન આવ્યા હોત તો મારો દેહ ત્યાં જ પડત.'
                                                    વાત સાંભળી મિણલદે સમજી ગયાં કે, રામદેવજીને આવેલું સ્વપ્ન સાચું હતું છતાં આશ્ચર્ય સાથે પૂછ્યું :
                                                    ‘બેટા સગુણા ! રામદેવજીએ વહાર કરી, એ તું શું બોલી ?'
                                                    ‘માતાજી ! ભાઈએ તો તુંવરાકુળની લાજ રાખી. મારા સસરાને પરચો બતાવ્યો, રતનાને કેદમાંથી છોડાવ્યો. રણવગડે લૂંટારાઓને ભાઈએ ઠાર મારી મને બધો માલ પાછો લાવી આપ્યો, તેથી હું બોલી.' સગુણાએ આખી વાત વિગતથી કહી સંભળાવી.
                                                    ‘બહેન ! રામદેવ તો અહીં જ છે, ક્યાંય ગયા જ નથી. માતાજીનાં વચન સાંભળી રામદેવજી ખડખડાટ હસી પડ્યા અને માતાજીની શંકા દૂર કરવા તલવાર કાઢીને તલવાર બતાવતાં બોલ્યા :
                                                    ‘માતાજી ! આ તલવાર વડે જ બહેનના લૂંટનારાઓને માર્યા. લૂંટારાઓને વહારે આવેલી દિલ્હીની ફોજને પણ આ જ તલવાર વડે પરાજીત કરી અને બાદશાહને નમાવ્યો. જોઈ લો ! આ મોગલોના લોહીની તરસી તલવાર.' માતાજી તલવારને લોહીવાળી જોઈ આશ્ચર્ય પામ્યાં. ત્યારબાદ સગુણાના કુંવરને બેચેની થતી હોવાથી સગુણા રણુંજામાં રહી અને જાન ઉમરકોટ જવા તૈયાર થઈ.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>{" "}
                </div>
            </div>
            {/* </div>
      </div> */}
            <div>
                <Footer />
                {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
            </div>
        </>
    );
};

export default BlogDetails22;
